
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dostep-ograniczony",
      function () {
        return require("private-next-pages/dostep-ograniczony/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dostep-ograniczony"])
      });
    }
  